module.exports = __webpack_public_path__ + "media/theme/how-it-works-close-01-b94283f2.png";